module.exports = __webpack_public_path__ + "static/media/gallery24.2348e4be.png";